import { render, staticRenderFns } from "./ContentRU.vue?vue&type=template&id=7c058162"
import script from "./ContentRU.vue?vue&type=script&lang=js"
export * from "./ContentRU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports